import React from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'

interface ErrorMessageRhfProps {
  errors: FieldErrors
  fieldName: string
  className?: string
}

const ErrorMessageRhf: React.FC<ErrorMessageRhfProps> = ({ errors, fieldName, className }) => {
  const { t } = useTranslation()
  const errorMessage = errors?.[fieldName]?.message

  if (errorMessage && typeof errorMessage === 'string') {
    return (
      <p className={twMerge('mt-2 text-left text-sm text-danger', className)}>{t(errorMessage)}</p>
    )
  }

  return null
}

export default ErrorMessageRhf
